import {convertHeightToPx} from './height'
import type {Converter, ConverterArguments, HeightConverterKey} from '../types'
import {calculateHeightBasedOnChildren, clampMinMax, getValue} from '../utils'
import {convertWidthToPx} from './width'

export const convertRowToPx: Record<HeightConverterKey, Converter> = {
    ...convertHeightToPx,
    MinMaxSize: minMaxSize,
    auto,
    percentage, // depends on comp height
    fit: auto,
    maxContent: auto,
    minContent: auto,
    fr: auto
}

function auto(converterArguments: ConverterArguments) {
    const {rowChildren} = converterArguments
    return rowChildren && rowChildren.length > 0
        ? calculateHeightBasedOnChildren(converterArguments, convertWidthToPx, rowChildren)
        : 0
}

function percentage(converterArguments: ConverterArguments) {
    const {compRef, measurementsMapAPI, value} = converterArguments
    const {get} = measurementsMapAPI

    const compHeight = get.height(compRef)
    if (typeof compHeight === 'number' && Number.isFinite(compHeight)) {
        return (value / 100) * compHeight
    }

    return auto(converterArguments)
}

function minMaxSize(converterArguments: ConverterArguments) {
    const {min, max, rowChildren} = converterArguments
    const minPx =
        (min &&
            convertRowToPx[min.type]({
                ...converterArguments,
                value: getValue(min)
            })) ??
        0
    if (!rowChildren) return minPx

    const maxPx =
        (max &&
            convertRowToPx[max.type]({
                ...converterArguments,
                value: getValue(max)
            })) ??
        undefined

    const contentHeight = convertRowToPx.auto(converterArguments)
    return clampMinMax(contentHeight, minPx, maxPx)
}
